<template>
  <div class="container-info-user container">
    <q-card>
      <q-expansion-item
        expand-separator
        :label="'Información sobre ' + userName"
        default-opened
      >
      <transition name="expand">
        <q-card-section key="external" class="q-pt-none q-col-gutter-y-sm" v-if="isExternal">
          <div class="row q-col-gutter-md col-12">
            <div class="col-4">
              <q-input
                data-cy="nombre-external"
                v-model="v$.external.name.$model"
                outlined
                :error="v$.external.name.$error"
                label="*Nombre"
                class="col-12"
                debounce="1000"
              >
                <template v-slot:error>Dato obligatorio.</template>
              </q-input>
            </div>
            <div class="col-8">
              <q-input
                v-model="v$.external.surNames.$model"
                outlined
                :error="v$.external.surNames.$error"
                label="*Apellidos"
                class="col-12"
                debounce="1000"
              >
                <template v-slot:error>Dato obligatorio.</template>
              </q-input>
            </div>
          </div>
          <div class="row q-col-gutter-md col-12">
            <div data-cy="field-external-entidad" class="col-12">
              <MultiSelectPredictive
                  :labelBox="{
                    select: 'Entidad'
                  }"
                  labelDataCy="entidad-servicio-multi-select"
                  endPoint="EntidadUser"
                  :dataObj="arrayUser"
                  relationShip="entidad-relationship"
                  :arraySelected="entidadesSelected"
                  :arrayAll="arrayEntidades"
                  :eventSave="events.saveEntidades"
                  :isMandatory=false
                  :isDisabled="isDisabledSelectedEntity"
                >
              </MultiSelectPredictive>
            </div>
          </div>
          <div class="row q-col-gutter-md col-12">
            <div class="col-5">
              <q-input
                v-model="external.phone"
                outlined
                label="Teléfono"
                class="col-12"
                :rules="[(val) => !val || validateTfno(val) || 'Teléfono no válido']"
                debounce="1000"

              >
                <template v-slot:error>Dato obligatorio.</template>
              </q-input>
            </div>
            <div class="col-7">
              <q-input
                v-model="v$.external.email.$model"
                outlined
                :error="v$.external.email.$error"
                label="*Email"
                class="col-12"
                debounce="1000"
                :rules="[
                  (val) => validateEmail(val) || 'Correo electrónico no válido',
                ]"
              >
                <template v-slot:error>Dato obligatorio.</template>
              </q-input>
            </div>
          </div>
          <div class="row q-col-gutter-md col-12">
            <div class="col-12">
              <q-input
                data-cy="external-update-company"
                v-model="external.company"
                :error="v$.external.company.$error"
                outlined
                label="*Empresa"
                class="col-12"
                debounce="1000"
                :rules="[
                      (val) =>
                        !checkIfFieldEmpty(val) || 'Empresa no válida',
                    ]">
                <template v-slot:error>Dato obligatorio.</template>
              </q-input>
            </div>
          </div>
          <div class="row q-col-gutter-md col-12">
            <div class="col-12">
              <q-select
                data-cy="locale"
                outlined
                v-model="external.locale"
                :options="languages"
                option-value="id"
                option-label="name"
                label="Idiomas"
              >
                <template v-slot:error>Dato obligatorio.</template>
              </q-select>
            </div>
          </div>
        </q-card-section>

        <q-card-section key="internal" class="q-pt-none q-col-gutter-y-sm" v-else>
          <div class="row q-col-gutter-md col-12">
            <div class="col-12">
              <q-field label="Email" data-cy="email-internal" outlined stack-label>
                <template v-slot:control>
                  <div class="self-center full-width no-outline" tabindex="0">
                    {{ v$.external.email.$model }}
                  </div>
                </template>
              </q-field>
            </div>
          </div>
          <div class="row q-col-gutter-md col-12">
            <div class="col-6">
              <q-field label="Nombre" outlined stack-label>
                <template v-slot:control>
                  <div class="self-center full-width no-outline" tabindex="0">
                    {{ v$.external.name.$model }}
                  </div>
                </template>
              </q-field>
            </div>
            <div class="col-6">
              <q-field label="Apellidos" outlined stack-label>
                <template v-slot:control>
                  <div class="self-center full-width no-outline" tabindex="0">
                    {{ v$.external.surNames.$model }}
                  </div>
                </template>
              </q-field>
            </div>
          </div>
        </q-card-section>
      </transition>
        <div class="row col-12">
          <div class="col-12 text-center">
            <q-toggle
              color="primary"
              v-model="isEnabled"
              label="Activado"
              left-label
            />
          </div>
        </div>
      </q-expansion-item>
    </q-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Message from '@/components/shared/mixins/Message.js';
import Loading from '@/components/shared/mixins/Loading.js';
import { QToggle, QField, QExpansionItem } from 'quasar';
import { required } from '@vuelidate/validators';
import Validation from '@/components/shared/mixins/Validation.js';
import { useVuelidate } from '@vuelidate/core';
import MultiSelectPredictive from '@/shared/multi-select-predictive/MultiSelectPredictive.vue';

export default {
  setup: () => ({ v$: useVuelidate() }),
  components: { QToggle, QField, QExpansionItem, MultiSelectPredictive },
  mixins: [Message, Validation, Loading],
  props: {
    dataUser: Object
  },
  computed: {
    userName () {
      return (
        this.arrayUser.user.name + ' ' + this.arrayUser.user.surNames
      );
    },
    isExternal () {
      return !this.arrayUser.user.internal;
    },
    ...mapGetters({
      isAdmin: 'PF/isAdmin',
      isSuperAdmin: 'PF/isSuperAdmin',
      isAdminEntidad: 'PF/isAdminEntidad',
      isDeliveryUser: 'PF/isDeliveryUser'
    })
  },
  validations: {
    external: {
      name: { required },
      surNames: { required },
      email: { required },
      company: { required }
    }
  },
  data () {
    return {
      value: false,
      isEnabled: false,
      arrayUser: this.dataUser,
      external: {
        name: null,
        surNames: null,
        phone: null,
        company: null,
        email: null,
        username: null,
        locale: { name: 'Español', id: 'es' }
      },
      languages: [{ name: 'Español', id: 'es' }, { name: 'Inglés', id: 'en' }, { name: 'Catalán', id: 'ca' }],
      dataEntidad: {
        id: null,
        entidades: []
      },
      entidadesSelected: null,
      arrayEntidades: [],
      events: {
        saveEntidades: 'GUARDAR_ENTIDADES_EDIT'
      },
      checkSave: {
        isEntidadesSave: null
      },
      isDisabledSelectedEntity: false
    };
  },
  async created () {
    await this.getEntidades();
    if ((!this.isSuperAdmin && !this.isAdminEntidad) || this.isDeliveryUser) {
      this.isDisabledSelectedEntity = true;
    }
  },
  mounted () {
    this.$eventHub.$on('ACTUALIZAR_INFORMACION', ({ callback }) =>
      this.saveValue(callback)
    );
  },
  beforeDestroy () {
    this.$eventHub.$off('ACTUALIZAR_INFORMACION');
  },
  methods: {
    async getEntidades () {
      this.showLoading();
      let request = {
        controller: '/Entidad/AdminEntidadByUser'
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then(response => {
          this.arrayEntidades = response.data;
          this.hideLoading();
        })
        .catch(err => {
          this.showError(err.message);
          this.hideLoading();
        });
    },
    checkValidate () {
      let hasError = false;

      this.v$.external.$touch();

      if (this.v$.$error ||
        (!this.validateTfno(this.external.phone) && this.external.phone) ||
        !this.validateEmail(this.external.email) ||
        this.checkIfFieldEmpty(this.external.company)
      ) {
        hasError = true;
      }

      return hasError;
    },
    prepareData () {
      let dataArray = {};
      dataArray = {
        user: {
          email: this.external.email,
          enabled: this.isEnabled,
          password: '',
          username: this.external.username,
          name: this.external.name,
          surNames: this.external.surNames,
          attributes: {
            phone: this.external.phone,
            locale: this.external.locale !== undefined ? this.external.locale.id : '',
            company: this.external.company
          }
        }
      };
      return dataArray;
    },
    async saveEntidades (id) {
      await this.$eventHub.$emit(this.events.saveEntidades, id, {
        callback: x => {
          this.checkSave.isEntidadesSave = x.status;
        },
        rejected: x => {
          this.checkSave.isEntidadesSave = x.status;
        }
      });
    },

    async saveDataUser (dataArray, responseData) {
      let request = {
        controller: '/User/' + this.arrayUser.id,
        filter: {},
        body: dataArray
      };
      await this.$store
        .dispatch('PF/putSuit', request)
        .then((response) => {
          // Si se quiere avisar de que se han asignado las aplicaciones al usuario
          responseData = {
            data: response.data,
            status: true
          };
          this.hideLoading();
        })
        .catch((err) => {
          this.hideLoading();
          this.showError(err.message);
          responseData = {
            data: null,
            status: false
          };
        });
      return responseData;
    },
    async saveValue (callback) {
      this.showLoading();
      let dataArray = {};
      let haveError = false;

      haveError = this.checkValidate();
      dataArray = this.prepareData();
      let responseData = null;

      if (!haveError) {
        if (!this.isDeliveryUser) {
          this.saveEntidades(this.arrayUser);
        }
        responseData = await this.saveDataUser(dataArray, responseData);
      } else {
        this.hideLoading();
        responseData = {
          data: null,
          status: false
        };
      }
      callback(responseData);
    },
    resetData () {
      this.external.email = null;
      this.external.name = null;
      this.external.surNames = null;
      this.entidadesSelected = null;
      this.external.phone = null;
      this.external.company = null;
      this.external.locale = null;
      this.isEnabled = false;
    },
    refillData () {
      this.external.email = this.arrayUser.user.email;
      this.external.name = this.arrayUser.user.name;
      this.external.surNames = this.arrayUser.user.surNames;
      this.entidadesSelected = this.arrayUser.entidades;
      this.external.phone = this.arrayUser.user.attributes.phone;
      this.external.company = this.arrayUser.user.attributes.company;
      this.external.locale = this.fillLocale(this.arrayUser.user.attributes.locale);
      this.external.username = this.arrayUser.user.userName;
      this.isEnabled = this.arrayUser.user.enabled;
    },
    fillLocale () {
      switch (this.arrayUser.user.attributes.locale) {
        case 'es':
          return { name: 'Español', id: 'es' };
        case 'en':
          return { name: 'Inglés', id: 'en' };
        case 'ca':
          return { name: 'Catalán', id: 'ca' };
        default:
          break;
      }
    }
  },
  watch: {
    dataUser: {
      handler: function () {
        this.arrayUser = this.dataUser;
        if (Object.entries(this.dataUser).length > 0) {
          this.refillData();
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.expand-enter-active, .expand-leave-active {
  transition: all 1s ease-in-out;
  max-height: 300px;
  overflow: hidden;
}
.expand-enter,
.expand-leave-to {
  max-height: 0;
  opacity: 0
}
.container-info-user {
  &:deep() {
    .q-expansion-item__toggle-icon--rotated {
      transform: rotate(-90deg);
    }

    .q-item {
      padding: 0 0 40px 0;
    }
  }

  #container-input {
    padding-top: 28px;
  }
}
</style>
